jQuery(document).ready(function($) {
  if ( $('.o-large-project-feed__filter')[0] ) {
    let pendingLoad = 0;

    $('.o-large-project-feed__filter .a-filter-link').click(function() {
      if ( !pendingLoad ) {
        const $filter       = $(this);
        const $filters      = $filter.closest('ul').find('button');
        const $filterParent = $filter.closest('.m-filter-links');
        const $feedList     = $('.o-large-project-feed__projects .m-large-projects__list');
        const $button       = $('.o-large-project-feed__button');
  
        const activeFilter = $(this).attr('data-filter');
  
  
        $filters.removeClass('a-filter-link--active');
        $filter.addClass('a-filter-link--pending');

        $.ajax({
          type: "POST",
          url: AJAX.url, // jshint ignore:line
          data: {
            action      : "get_portfolio_projects",
            nonce       : AJAX.nonce, // jshint ignore:line
            postCount   : 0,
            activeFilter: activeFilter
          },
          dataType: "json",
          beforeSend: function () {
            pendingLoad++;
          },
          success: function (results) {
            if (results.data.items) {
              $feedList.empty();
              $feedList.append(results.data.items);
              $filter
                .removeClass('a-filter-link--pending')
                .addClass('a-filter-link--active');

              $filterParent.find('.m-filter-links__toggle').text($filter.text());

              if ( $(window).width() <= 768 ) {
                setTimeout(function() {
                  $filterParent.trigger('unexpand');
                }, 800);
              }

              // Fake browser url change w/ parameter
              if ( activeFilter !== 'all' ) {
                window.history.pushState(
                    window.location.origin + window.location.pathname,
                    $filter.text() + " Projects",
                    "?service=" + activeFilter
                );
              }
              // Otherwise, clear parameter from url
              else {
                  window.history.pushState(
                      window.location.origin + window.location.pathname,
                      $filter.text() + " Projects",
                      '?service=all'
                  );
              }

              setTimeout(function() {
                $feedList.find('.m-large-project__item--loaded').addClass('aos-animate');
              }, 10);
            }

            // Remove button if no more post pages
            if (results.data.hideButton) {
              $button.addClass('o-large-project-feed__button--hide');
            } else {
              $button.removeClass('o-large-project-feed__button--hide');
            }

            $button.removeClass('a-arrow-button--loading');
            $button.find('.a-arrow-button__text').text('Load More');
          },
          complete: function () {
            pendingLoad--;
          }
        });
      }
    });
  }

  if ( $('.o-large-project-feed__button')[0] ) {
    let pendingLoad = 0;

    $('.o-large-project-feed__button').click(function() {
      if ( !pendingLoad ) {
        const $button     = $(this);
        const $buttonText = $button.find('.a-arrow-button__text');
  
        const $filterList = $('.o-large-project-feed__filter');
        const $feedList   = $('.o-large-project-feed__projects .m-large-projects__list');
  
        const postCount    = $feedList.find('.m-large-projects__item').length;
        const activeFilter = $filterList.find('.a-filter-link--active').attr('data-filter');
  
  
        $button.addClass('a-arrow-button--loading');
        $buttonText.text('Loading...');

        $.ajax({
          type: "POST",
          url: AJAX.url, // jshint ignore:line
          data: {
            action      : "get_portfolio_projects",
            nonce       : AJAX.nonce, // jshint ignore:line
            postCount   : postCount,
            activeFilter: activeFilter
          },
          dataType: "json",
          beforeSend: function () {
            pendingLoad++;
          },
          success: function (results) {
            if (results.data.items) {
              $feedList.append(results.data.items);
              
              // Trigger image animation
              setTimeout(function() {
                $feedList.find('.m-large-project__item--loaded').addClass('aos-animate');
              }, 10);
            }

            // Remove button if no more post pages
            if (results.data.hideButton) {
              $button.addClass('o-large-project-feed__button--hide');
            }
            // Otherwise, remove loading state
            else {
              $button.removeClass('o-large-project-feed__button--hide');
            }

            $button.removeClass('a-arrow-button--loading');
            $buttonText.text('Load More');
          },
          complete: function () {
            pendingLoad--;
          }
        });
      }
    });
  }

});